export default __webpack_public_path__ + "static/media/instagramIcon.c4146446.svg";